import { Button } from 'react-bootstrap';
import './style.css';
import { useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { CadastroContext } from '../../../../contexts/CadastroContext';

interface FaturamentoMensal {
    faturamentoDe: number | null;
    faturamentoAte: number | null;
}

const AsoFaturamentoMensalEmpresa = () => {
    const navigate = useNavigate();
    const { cadastro, handleCadastroChange } = useContext(CadastroContext);
    const [options] = useState([15000, 30000, 60000, 150000, 300000, 400000]);
    const [selectedOption, setSelectedOption] = useState<number | null>(null);
    const [outsideButtonChecked, setOutsideButtonChecked] = useState(false);
    const [selectedFaturamento, setSelectedFaturamento] = useState<FaturamentoMensal>({
        faturamentoDe: null,
        faturamentoAte: null
    });

    const handleButtonClick = (index: number, option?: number) => {
      setSelectedOption(index);
      setOutsideButtonChecked(false);
      if (index === 0) {
            // Selecionou o primeiro botão, faturamento "Até"
            setSelectedFaturamento({ faturamentoDe: null, faturamentoAte: options[index] });
        } else if (index === options.length - 1) {
            // Selecionou o último botão, faturamento "De"
            setSelectedFaturamento({ faturamentoDe: options[index - 1] + 0.01, faturamentoAte: null });
            !option ? setOutsideButtonChecked(true) : setOutsideButtonChecked(false);
        } else {
            // Selecionou um botão com duas opções
            setSelectedFaturamento({ faturamentoDe: options[index - 1] + 0.01, faturamentoAte: options[index] });
        }
    };

    const handleContinuar = () => {
        if (!selectedFaturamento.faturamentoDe && !selectedFaturamento.faturamentoAte) alert('Selecione uma opção');
        if (selectedFaturamento.faturamentoDe) cadastro.faturamentoDe = selectedFaturamento.faturamentoDe;
        if (selectedFaturamento.faturamentoAte) cadastro.faturamentoAte = selectedFaturamento.faturamentoAte;
        handleCadastroChange(cadastro);
        navigate('/aso/registro/empresa-beneficiarios-finais');
    }

    const formatOptionText = (index: number, value: number) => {
        const lastIndex = options.length - 1;
    
        if (index === 0) {
            // Primeiro item
            return `Até ${value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}.`;
        } else {
            // Todos os outros itens
            const previousValue = options[index - 1] + 0.01;
            if (index === lastIndex - 1) {
                // Penúltimo item
                return `De ${previousValue.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })} até ${value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}.`;
            } else if (index === lastIndex) {
                // Último item
                const lastValue = options[lastIndex - 1] + 0.01;
                return `De ${lastValue.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })} até ${value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}.`;
            } else {
                // Índices intermediários
                return `De ${previousValue.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })} até ${value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}.`;
            }
        }
    };

    return (
        <div className='aso-faturamento-body'>
            <div className='aso-faturamento-title-container'>
                <div className='aso-faturamento-title-text'>Qual é o faturamento mensal da sociedade?</div>
                <div className='aso-faturamento-subtitle-text'>Adicione todo o faturamento por vendas de mercadorias ou serviços.</div>
            </div>
            <div className='container'>
                <div className='aso-faturamento-listagem-valores-container'>
                    {options.map((option, index) => (
                        <Button key={index} className="aso-faturamento-botao" onClick={() => handleButtonClick(index, option)}>
                            <div className="aso-faturamento-texto-botao">
                                {formatOptionText(index, option)}
                            </div>
                            <div className="aso-faturamento-radio-wrapper">
                                <input type='radio' className='aso-faturamento-radio-button' readOnly checked={selectedOption === index && !outsideButtonChecked}/>
                            </div>
                        </Button>
                    ))}
                    <Button key={options.length - 1} className="aso-faturamento-botao" onClick={() => handleButtonClick(options.length - 1, undefined)}>
                        <div className="aso-faturamento-texto-botao">
                            {`Mais de ${(options[options.length - 1] + 0.01).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}`}
                        </div>
                        <div className="aso-faturamento-radio-wrapper">
                            <input type='radio' className='aso-faturamento-radio-button' checked={outsideButtonChecked}/>
                        </div>
                    </Button>
                </div>
                <div className='aso-faturamento-continuar-button-container-mobile'>
                    <div className='aso-faturamento-continuar-button-container'>
                        <Button className='aso-faturamento-continuar-button' onClick={() => navigate('/aso/registro/endereco-empresa')}>
                            Voltar
                        </Button>
                        <Button className='aso-faturamento-continuar-button' onClick={handleContinuar}>
                            Continuar
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    );
}


export default AsoFaturamentoMensalEmpresa;